<script setup lang="ts">
import { onMounted, ref } from "vue";
import { postNABatFileListAuth } from "@/api/NABatApi";
import useNABatTokens from "@/use/useNABatTokens";
import { useRouter } from "vue-router";

const { setApiToken, setRefreshToken } = useNABatTokens();

const props = defineProps<{
  iss: string;
  code: string;
  fileListId: string;
}>();

const router = useRouter();

const loading = ref(false);
const message = ref("");

async function initiateTokenExchange() {
  loading.value = true;
  try {
    const exchangeData = await postNABatFileListAuth(
      props.fileListId,
      props.iss,
      props.code,
    );
    if (exchangeData["access_token"] && exchangeData["refresh_token"]) {
      setApiToken(exchangeData["access_token"]);
      setRefreshToken(exchangeData["refresh_token"]);
      // Redirect to the file list page
      router.push(`/nabat/file-list/${props.fileListId}/`);
    }
  } catch {
    message.value = "Failed to authorize with NABat.";
  } finally {
    loading.value = false;
  }
}

onMounted(async () => initiateTokenExchange());
</script>

<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-spacer />
        <v-col justify="center" cols="auto">
          <v-progress-circular
            v-if="loading"
            indeterminate
            :size="256"
            :width="30"
            color="primary"
          >
            Loading...
          </v-progress-circular>
          <v-banner v-else>
            <v-banner-text>{{ message }}</v-banner-text>
          </v-banner>
        </v-col>
        <v-spacer />
      </v-row>
    </v-card-text>
  </v-card>
</template>
